import { render } from "./StockTaking.vue?vue&type=template&id=2c2673d1&scoped=true"
import script from "./StockTaking.vue?vue&type=script&lang=js"
export * from "./StockTaking.vue?vue&type=script&lang=js"

import "./StockTaking.vue?vue&type=style&index=0&id=2c2673d1&scoped=true&lang=css"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2673d1"]])

export default __exports__